module.exports = __webpack_public_path__ + "static/media/wallet.5b39856d.svg";